import { css } from '@emotion/css';

import {
  Colors,
  FontWeight,
  LineHeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const suggestionsClassName = css({
  display: 'flex',
  marginTop: Spacing['2XS'],
  overflowX: 'auto',
  [SMALL_DEVICE_MQ]: {
    flexWrap: 'wrap',
  },
});

export const suggestionClassName = css({
  alignItems: 'center',
  background: 'transparent',
  borderRadius: 100,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  marginRight: Spacing.XS,
  marginTop: Spacing.SM,
  minHeight: 40,
  padding: `${Spacing.XS}px 20px`,
  transition: '0.2s',
});

export const labelClassName = css({
  color: Colors.Primary,
  display: 'block',
  fontSize: 14,
  fontWeight: FontWeight.BOLD,
  lineHeight: LineHeight.COMPACT,
  whiteSpace: 'nowrap',
});

export const purpleColorStyle = {
  background: 'rgba(189, 95, 255, 0.1)',
  '&:hover': {
    background: 'rgba(189, 95, 255, 0.2)',
  },
};

export const redColorStyle = {
  background: 'rgba(255, 95, 95, 0.1)',
  '&:hover': {
    background: 'rgba(255, 95, 95, 0.2)',
  },
};

export const greenColorStyle = {
  background: 'rgba(121, 214, 181, 0.1)',
  '&:hover': {
    background: 'rgba(121, 214, 181, 0.2)',
  },
};

export const yellowColorStyle = {
  background: 'rgba(255, 211, 29, 0.1)',
  '&:hover': {
    background: 'rgba(255, 211, 29, 0.2)',
  },
};

export const pinkColorStyle = {
  background: 'rgba(244, 113, 255, 0.1)',
  '&:hover': {
    background: 'rgba(244, 113, 255, 0.2)',
  },
};

export const blueColorStyle = {
  background: 'rgba(95, 127, 255, 0.1)',
  '&:hover': {
    background: 'rgba(95, 127, 2555, 0.2)',
  },
};
